<template>
  <v-row>
    <v-col cols="12">
      <UserHeader />
    </v-col>
    <v-col cols="12">
      <Contributors v-if="id == '/users/contributors'" />
      <Designers v-else-if="id == '/users/designers'" />
      <Users v-else />
    </v-col>
  </v-row>
</template>

<script>
import Contributors from '@/components/users/Contributors';
import Designers from '@/components/users/Designers';
import UserHeader from '@/components/users/Header';
import Users from '@/components/users/Users';
export default {
  name: 'UsersIndex',
  components: { UserHeader, Users, Contributors, Designers },
  computed: {
    id() {
      return this.$route.path;
    }
  },
  async mounted() {
    if (this.$route.query.search) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.SEARCH_USERS, this.$route.query.search);
    }
    // await Promise.all([
    //   this.$store.dispatch("lookup/getCategories"),
    //   this.$store.dispatch("lookup/getDesignGroups"),
    //   this.$store.dispatch("lookup/getDesigners"),
    //   this.$store.dispatch("lookup/getProducts")
    // ]);
  }
};
</script>
